<ion-app>

  <app-mobile-menu [currentURL]="currentURL"></app-mobile-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
  <img id="itemToBeAdded" class="itemToBeAdded">
</ion-app>